import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { useModal } from "../../contexts/ModalContext";
import BookingPopup from "../../components/BookingPopup";

export default function HomeSolutions() {
  const [showSerachEngine, setshowSerachEngine] = useState(false);
  const sliderData = [
    {
      img: "/assets/images/solutons-slider1.webp",
      heading: "Residential Dumpster",
      text: "Easy, affordable dumpster rentals for all home cleanups and other renovation projects.",
      btn1: "Book Online",
      btn2: "Call Us Now",
    },
    {
      img: "/assets/images/solutons-slider2.webp",
      heading: "Construction Dumpsters",
      text: "Reliable, heavy-duty dumpsters for all construction debris and site cleanup projects.",
      btn1: "Book Online",
      btn2: "Call Us Now",
    },
    {
      img: "/assets/images/solutons-slider3.webp",
      heading: "Commercial Dumpsters",
      text: "Efficient, affordable waste solutions for all business and property management needs.",
      btn1: "Book Online",
      btn2: "Call Us Now",
    },





  ];

  const settings = {
    dots: false,
    autoplay: true,
    pauseOnFocus: false,
    pauseOnHover: true,
    arrows: true,
    cssEase: "ease",
    speed: 3000,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    prevArrow: (
      <button className="slick-arrow slick-prev" aria-label="Previous Slide">
        <i className="fa-solid fa-arrow-left"></i>
      </button>
    ),
    nextArrow: (
      <button className="slick-arrow slick-next" aria-label="Next Slide">
        <i className="fa-solid fa-arrow-right"></i>
      </button>
    ),

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      }
      ,
      {
        breakpoint: 9999,
        settings: "unslick",
      },


    ],



  };

  return (
    <>
      <section className="home-solutions space">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-8">
              <div className="services-text">
                <h2 className="heading">Reliable Dumpster  <br /> Solutions for Every Need</h2>
                <p>From small home cleanups to large construction projects, Big Bin offers a range of dumpster sizes designed to handle     waste efficiently and fit your specific requirements.</p>
              </div>
            </div>
          </div>

          <div className="solutions-slider">
            <Slider {...settings} className="slider-solutions">
              {sliderData.map((item, index) => (
                <div className="solutions-cols" key={index}>
                  <div className="solutions-images">
                    <div className="solutions-images-inner">
                      <img src={item.img} className="img-responsive" alt="Slider" loading="lazy" />
                    </div>
                    <div className="solutions-content">
                      <div className="heading">{item.heading}</div>
                      <p>{item.text}</p>
                      <div className="solutions-btns">
                        <div className="solutions-btns-inner">
                          <Link onClick={() => setshowSerachEngine(true)} className="theme-btn first-btn" > <span className="color-overlay"></span> <span className="btn-txt">{item.btn1}</span></Link>
                          <Link to="/contact-us/" className="theme-btn second-btn" ><span className="color-overlay"></span><span className="btn-txt">{item.btn2}</span> </Link>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
      <BookingPopup isOpen={showSerachEngine} onClose={() => setshowSerachEngine(false)} />
    </>


  );
}
